import IconButton from '@material-ui/core/IconButton'
import AddIcon from '@material-ui/icons/Add'
import { makeStyles } from '@material-ui/core/styles'

type NewChatButtonProps = {
  onClick: () => void
}

const useStyles = makeStyles((theme) => ({
  button: {
    width: 40,
    height: 40,
    borderRadius: theme.spacing(1),
    color: theme.palette.common.white,
    backgroundColor: 'var(--ds-accent-primary, #f47d6b)',
    '&:hover': {
      backgroundColor: 'var(--ds-accent-primary-light, #f68778)',
    },
    '&:focus-visible': {
      boxShadow: '0 0 0 2px rgba(244, 125, 107, 0.35)',
    },
    '& .MuiSvgIcon-root': {
      color: '#ffffff',
    },
  },
}))

const NewChatButton = ({ onClick }: NewChatButtonProps) => {
  const classes = useStyles()

  return (
    <IconButton className={classes.button} disableRipple onClick={onClick} aria-label="New chat">
      <AddIcon fontSize="small" />
    </IconButton>
  )
}

export default NewChatButton
